import React, { useState, useEffect, useContext } from "react";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditIcon from "@mui/icons-material/Edit";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import { batiment } from "variables/patrimoine.js";
import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import { ActionContext } from "context/ActionContext";
import { IntInput } from "components/Input/Index.js";
import useActionTable from "./useActionTable.js";

//import "react-table/react-table.css";

// @mui/icons-material

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const RTPotentials = ({ planActionId, planActionName }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState, refreshTable } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [editableRowId, setEditableRowId] = useState(false);

  const [newData, setNewData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  //console.log(actionPlans.parameters.general.groups);

  // if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Oups il semble y avoir un problème...{" "}
  //       <button onClick={refetch}>Réesayer</button>
  //     </p>
  //   );
  // }

  function indexFinder(rowId) {
    const indexOfId = newData.findIndex((obj) => obj.name == rowId);

    return indexOfId;
  }
  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Surface",
      selector: (row) => row.surface,
      sortable: true,
      cell: (row) =>
        editableRowId === row.name ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.name)].surface}
            handleIntInputChange={(e) => handleChange(e, row.name)}
            name="surface"
          />
        ) : (
          row.surface
        ),
    },
    {
      name: "Compatibilité chauffage",
      selector: (row) => row.compatibility,
      sortable: true,
    },
    {
      name: "Faisabilité",
      selector: (row) => row.faisability,
      sortable: true,
    },
    // actionplanupdate && {
    //   name: "Commentaires",
    //   selector: (row) => row.comments,
    //   sortable: true,
    //   cell: (row) =>
    //     editableRowId === row.name ? (
    //       <IntInput
    //         //inputTitle={actionVar[params].observations}
    //         intInput={newData[indexFinder(row.name)].comments}
    //         handleIntInputChange={(e) => handleChange(e, row.name)}
    //         name="comments"
    //       />
    //     ) : (
    //       row.comments
    //     ),
    // },
    // {
    //   name: "",
    //   sortable: false,
    //   width: "4rem",
    //   // eslint-disable-next-line react/button-has-type
    //   // eslint-disable-next-line react/display-name
    //   cell: (row) => (
    //     <>
    //       <div className="actions-right">
    //         <Tooltip title="Editer">
    //           <Button
    //             onClick={editEnabled(row)}
    //             color={editableRowId === row.name ? "info" : "success"}
    //             className={classes.actionButton}
    //           >
    //             {editableRowId === row.name ? (
    //               <CheckIcon fontSize="large" />
    //             ) : (
    //               <EditIcon fontSize="large" />
    //             )}
    //           </Button>
    //         </Tooltip>
    //       </div>
    //     </>
    //   ),
    // },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.name == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  const handleSelectedChange = ({ selectedRows }) => {
    selectedRows.map((equipment) => (equipment.isSelected = true));
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          equipments: selectedRows,
        },
      },
    }));
  };

  const editEnabled = (row) => async () => {
    editableRowId === row.name
      ? setEditableRowId(null)
      : setEditableRowId(row.name);
  };

  const reloadEquipment = (row) => async () => {
    let equipments = [...action.parameters.impact.equipments];

    let updatedEquipments = equipments.filter((item) => item.name !== row.name);

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          equipments: updatedEquipments,
        },
      },
    }));

    refreshTable();
  };

  const contextMessage = {
    singular: "équipement",
    plural: "équipements",
    message: "sélectionné(s)",
  };

  const rowSelectCritera = (row) => row.isSelected == true;
  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        //noHeader={true}
        //title="Liste des equipements"
        noDataComponent="Aucun ENR retrouvé dans le patrimoine"
        columns={columns}
        persistTableHead
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        {...gridState}
        contextMessage={contextMessage}
      />
    </>
  );
};

export default RTPotentials;
